import { render, staticRenderFns } from "./categorySlider.vue?vue&type=template&id=c2a39572&scoped=true&"
import script from "./categorySlider.vue?vue&type=script&lang=js&"
export * from "./categorySlider.vue?vue&type=script&lang=js&"
import style0 from "./categorySlider.vue?vue&type=style&index=0&id=c2a39572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a39572",
  null
  
)

export default component.exports